/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index card to autogenerate all the components and extensions
 * Used by "prepareCards"
 */

import Card from './card/Card'
export * from './card/Card'
export default Card
